import React from 'react';
import { 
  Box, 
  Button, 
  Typography, 
  Alert,
  CircularProgress,
  Divider,
  useTheme
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import usePriorityRetry from '../../../hooks/purchaseInvoices/invoiceManagement/usePriorityRetry';

const PriorityRetrySection = ({ invoice, approvalPackage }) => {
  const theme = useTheme();
  const { retryPriorityCreation, isRetrying } = usePriorityRetry(); 
  const shouldShowRetrySection = () => {
    return approvalPackage?.priorityCreationFailed === true && 
           approvalPackage?.allowRetry === true;
  };

  const handleRetry = () => {
    if (approvalPackage?._id) {
      retryPriorityCreation(approvalPackage._id);
    }
  };

  if (!shouldShowRetrySection()) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Divider sx={{ mb: 2 }} />
      
      <Alert 
        severity="warning" 
        icon={<ErrorOutlineIcon fontSize="inherit" />}
        sx={{ mb: 2 }}
      >
        <Typography variant="body2">
          <strong>שגיאה בקליטת החשבונית בפריוריטי</strong>
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          החשבונית לא הצליחה להיקלט במערכת הפריוריטי לאחר מספר ניסיונות. 
          ניתן לנסות שליחה מחדש או לפנות לתמיכה טכנית.
        </Typography>
        
        {approvalPackage?.lastError?.message && (
          <Typography variant="body2" sx={{ mt: 1, color: 'error.dark' }}>
            <strong>פרטי השגיאה:</strong> {approvalPackage.lastError.message}
          </Typography>
        )}
      </Alert>

      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: 2,
        p: 2,
        bgcolor: 'grey.50',
        borderRadius: 1,
        border: 1,
        borderColor: 'grey.200'
      }}>
        <Typography variant="h6" color="warning.main">
          שליחה חוזרת לפריוריטי
        </Typography>
        
        <Typography variant="body2" color="text.secondary">
          פעולה זו תשלח את החשבונית מחדש למערכת הפריוריטי. 
          הפעולה תבוצע ברקע ותקבל הודעה בסיומה.
        </Typography>

        <Button
          variant="contained"
          color="warning"
          startIcon={isRetrying ? <CircularProgress size={16} color="inherit" /> : <RefreshIcon />}
          onClick={handleRetry}
          disabled={isRetrying}
          sx={{
            alignSelf: 'flex-start',
            '&:hover': {
              bgcolor: theme.palette.warning.dark,
            }
          }}
        >
          {isRetrying ? 'שולח מחדש...' : 'שלח מחדש לפריוריטי'}
        </Button>
      </Box>
    </Box>
  );
};

export default PriorityRetrySection;
